const LEGACY_EMPLOYEE_USER_TYPES = new Set(["E", "O"]);

export type EffectiveOopsUserType = "C" | "E" | "O";

export interface OopsThemeAccessPayload {
    user_type?: unknown;
    oops_theme_access?: unknown;
}

/**
 * OOPS 테마 접근 가능 여부를 판정한다.
 *
 * 고객(C)은 기존 동작을 유지한다. 직원(E/O)은 새 서버가
 * oops_theme_access 필드를 제공하면 그 값을 우선하며, 필드가 아예 없는
 * 구버전 응답에 한해서만 기존 user_type 판정으로 호환한다. 서버가 명시적으로
 * 권한을 허용한 빈 타입 직원은 브라우저에서만 E로 취급한다.
 */
export function resolveEffectiveOopsUserType(
    payload: OopsThemeAccessPayload | null | undefined
): EffectiveOopsUserType | null {
    if(!payload){
        return null;
    }

    const userType = String(payload.user_type ?? "").trim().toUpperCase();

    if(userType === "C"){
        return "C";
    }

    const hasExplicitCapability = Object.prototype.hasOwnProperty.call(
        payload,
        "oops_theme_access"
    );

    if(LEGACY_EMPLOYEE_USER_TYPES.has(userType)){
        if(hasExplicitCapability && payload.oops_theme_access !== true){
            return null;
        }

        return userType as "E" | "O";
    }

    if(userType === "" && hasExplicitCapability && payload.oops_theme_access === true){
        return "E";
    }

    // F/P/PM/PI/A를 포함한 모든 비어 있지 않은 특수/미확인 타입은
    // capability 값만으로 직원 권한으로 승격하지 않는다.
    return null;
}

export function canAccessOopsTheme(payload: OopsThemeAccessPayload | null | undefined): boolean {
    return resolveEffectiveOopsUserType(payload) !== null;
}

export function isExplicitOopsThemeAccessDenied(
    payload: OopsThemeAccessPayload | null | undefined
): boolean {
    return Boolean(
        payload
        && Object.prototype.hasOwnProperty.call(payload, "oops_theme_access")
        && payload.oops_theme_access === false
    );
}
